const round0 = (value) => Math.round(value);

export function calculateItem(item) {
  const amount = round0(item.rate * item.quantity);
  const discount = round0(item.discount || 0);
  const total = round0(amount - discount);

  return {
    amount,
    discount,
    total,
  };
}

export function calculateTotals(items) {
  return items.reduce(
    (acc, item) => {
      acc.amount = round0(acc.amount + item.amount);
      acc.discount = round0(acc.discount + (item.discount || 0));
      acc.total = round0(acc.total + item.total);
      return acc;
    },
    {
      amount: 0,
      discount: 0,
      total: 0,
    }
  );
}